<template>
  <div id="app">

    <rxmenu/>

    <div class="content">
      <router-view/>
    </div>

    <!--<div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> |
      <router-link to="/authorization">Authorization</router-link>
    </div>-->

    

    <rxfooter/>


  </div>

</template>

<script>

import rxfooter from '@/components/rx/footer/index.vue'
import rxmenu from '@/components/rx/menu/index.vue'


export default {
    components: {
      rxfooter,
      rxmenu
    }
}

</script>

<style lang="sass" src="./index.sass"></style>


